<template>

    <div class="container login-page">
        <div class="row">
            <div class="offset-lg-3 col-lg-6 bg-ss-gray">
                <h2>{{ lang('all.login') }}</h2>

                <div
                    class="alert alert-info"
                    role="alert"
                    v-if="true === notverifiedyet"
                >
                    {{ lang('all.uw_account_is_nog_niet_geactiveerd_controleer_uw_e') }}
                    <a
                        href="javascript:void(0);"
                        @click.prevent="resendActivation"
                    >{{ lang('all.activatiemail_nogmaals_versturen') }}</a>
                </div>

                <div
                    class="alert alert-success"
                    role="alert"
                    v-if="verification_completed !== null"
                >
                    {{ verification_completed }}
                </div>

                <div
                    class="alert alert-danger"
                    role="alert"
                    v-if="verification_failed !== null"
                >
                    {{ verification_failed }}
                </div>

                <text-input
                    label=""
                    type="email"
                    placeholder="E-mailadres"
                    v-model="form.email"
                    :errors="errors.email"
                ></text-input>

                <text-input
                    label=""
                    type="password"
                    :placeholder="lang('all.wachtwoord')"
                    v-model="form.password"
                    :errors="errors.password"
                    @onEnter="login"
                ></text-input>

                <div class="row">
                    <div class="col-sm-6">
                        <label>
                            <input
                                type="checkbox"
                                v-model="form.rememberme"
                            />
                            {{ lang('all.onthoud_mij') }}
                        </label>
                    </div>
                    <div class="col-sm-6 text-right">
                        <button
                            :disabled="!canLogin"
                            @click="login"
                            class="btn btn-primary"
                        >
                            {{ lang('all.login') }}
                        </button>
                    </div>
                </div>

                <inertia-link
                    :href="route('guest.password.request')"
                >
                    {{ lang('all.wachtwoord_vergeten2') }}
                </inertia-link>

                <inertia-link
                    :href="route('guest.register')"
                >
                    {{ lang('all.geen_account') }}
                </inertia-link>
            </div>
        </div>
    </div>

</template>

<script>

import Layout from "../../Shared/Layout";
import TextInput from "../../Common/TextInput";
import {mapActions} from "vuex";

export default {

    components: {
        TextInput,
    },

    computed: {
        canLogin() {
            return this.posting === false;
        },

        canResendActivation() {
            return this.form.email !== '' &&
                this.posting === false;
        },
    },

    data() {
        return {
            form:{
                email:'',
                password:'',
                rememberme:false,
            },
            posting:false,
        }
    },

    layout:Layout,

    metaInfo() {
        return {
            title: 'Inloggen',
            meta: [
                {vmid:'keywords',name:'keywords',content:'inloggen,login'},
                {vmid:'description',name:'description',content:'Log in op onze webshop.'},
            ],
        }
    },

    methods: {
        ...mapActions([
            'fetchCart',
        ]),

        login() {
            if (!this.canLogin) {
                return;
            }
            this.posting = true;

            this.$inertia.post(this.route('guest.login'), this.form, {
                onFinish: () => {
                    this.posting = false;
                    this.fetchCart();
                },
            });
        },

        resendActivation() {
            if (this.form.email === '') {
                this.$snotify.error(this.lang('snotify.login_no_email'));
                return;
            }

            if (!this.canResendActivation) {
                return;
            }

            this.posting = true;

            this.$inertia.post(this.route('verification.resend'), {email:this.form.email}, {
                onFinish: () => this.posting = false,
            });
        },
    },

    name:'GuestLogin',

    props: {
        errors: {
            type:Object,
        },
        notverifiedyet: {
            type:Boolean,
            default:false,
        },
        verification_failed: {
            type:String,
            default:null,
        },
        verification_completed: {
            type:String,
            default:null,
        },
    },

}

</script>
